import axios from "axios";
import {api} from "../config";

axios.defaults.baseURL = api.API_URL;

axios.interceptors.response.use(
    function (response) {
        return response.data ? response.data : response;
    },
    function (error) {
        let message;
        if (error.response) {
            switch (error.response.status) {
                case 500:
                    message = "Server Error";
                    break;
                case 401: {
                    // Check if user is logged in (has token)
                    const token = localStorage.getItem("token");
                    if (token) {
                        // If user has token but gets 401, token is expired
                        message = "Your session has expired. Please log in again.";
                        // Auto logout and redirect
                        setTimeout(() => {
                            handleLogout();
                        }, 1000); // 1 second delay to show the message
                    } else {
                        // If no token, it's a login attempt
                        message = "Unauthorized - Invalid username or password";
                    }
                    break;
                }
                case 404:
                    message = error.response.data?.error || "Sorry, the page you are looking for was not found.";
                    break;
                case 422:
                    message = "Invalid data format";
                    break;
                default:
                    message = error.response.data?.error || error.response.data?.message || error.response.data || "Something went wrong";
            }
        } else if (error.request) {
            message = "Could not connect to server";
        } else {
            message = error.message || "Unknown error";
        }
        return Promise.reject(new Error(message));
    }
);

const setAuthorization = (token) => {
    axios.defaults.headers.common["Authorization"] = "Bearer " + token;
};

const setContentType = (contentType) => {
    axios.defaults.headers.common["Content-Type"] = contentType;
};

class APIClient {
    setContentType = (contentType) => {
        axios.defaults.headers.common["Content-Type"] = contentType;
    };
    get = (url, params) => {
        let response;

        let paramKeys = [];

        if (params) {
            Object.keys(params).map(key => {
                paramKeys.push(key + '=' + params[key]);
                return paramKeys;
            });

            const queryString = paramKeys && paramKeys.length ? paramKeys.join('&') : "";
            response = axios.get(`${url}?${queryString}`, params);
        } else {
            response = axios.get(`${url}`, params);
        }

        return response;
    };
    create = (url, data) => {
        return axios.put(url, data);
    };
    post = (url, data) => {
        return axios.post(url, data);
    };
    update = (url, data) => {
        return axios.put(url, data);
    };
    patch = (url, data) => {
        return axios.patch(url, data);
    };
    delete = (url, config) => {
        return axios.delete(url, {...config});
    };
}

const getLoggedinUser = () => {
    const authUser = JSON.parse(localStorage.getItem("authUser"));
    if (!authUser) {
        return null;
    } else {
        return authUser;
    }
};

const handleLogout = () => {
    // Clear all auth data from localStorage
    localStorage.removeItem("authUser");
    localStorage.removeItem("token");
    
    // Clear axios authorization header
    delete axios.defaults.headers.common["Authorization"];
    
    // Show toast message (if ToastAlert is available)
    if (window.showToastAlert) {
        window.showToastAlert("Your session has expired. Please log in again.", "warning");
    }
    
    // Redirect to login page
    setTimeout(() => {
        window.location.href = "/login";
    }, 500); // Small delay to show toast
};

export {APIClient, setAuthorization, getLoggedinUser, handleLogout};
